const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/uster/eCheckin/sections/Hausarzt.tsx';
import React, { forwardRef } from 'react';
import _ from 'lodash';
import { useText } from '@cistec/common_web/utils/intlUtils';
import { useCIS4m, useCIS4mData } from '@cistec/common_web/modules/CIS4m/hooks';
import { CIS4mSingleCheckbox } from '@cistec/common_web/modules/CIS4m/components/CIS4mSingleCheckbox';
import textMap from 'App/config/uster/eCheckin/translations';
import { createFieldPath } from 'App/components/eCheckin/utils';
import ECheckinSection from 'App/components/eCheckin/components/ECheckinSection';
import { ECheckinSectionProps } from 'App/components/eCheckin/types';
import { ArztBlock, ArztFieldsConfig } from 'App/components/eCheckin/components/fields/ArztBlock';
import { AddressFieldsConfig } from 'App/components/eCheckin/components/fields/AddressBlock';

const addressFieldsConfig: AddressFieldsConfig = {
    additionalInfo: {
        included: false,
    },
    country: {
        included: false,
    },
};

const arztFieldsConfig: ArztFieldsConfig = {
    tel: {
        required: false,
    },
};

export const Hausarzt = forwardRef((props: ECheckinSectionProps, ref: any) => {
    const { path } = props;
    const title = useText(props.title);

    const PATH_NO_FAMILY_DOCTOR = createFieldPath(path, 'noFamilyDoctor');

    const formData = useCIS4mData();
    const hasNoFamilyDoctor = _.get(formData, PATH_NO_FAMILY_DOCTOR) === '1';

    const eCheckinSectionRef = useCIS4m(ref);

    return (
        <ECheckinSection ref={eCheckinSectionRef} path={path} title={title}>
            <h1>{title}</h1>
            <CIS4mSingleCheckbox label={textMap.noFamilyDoctor} path={PATH_NO_FAMILY_DOCTOR} />
            <ArztBlock
                basePath={path}
                addressFieldsConfig={addressFieldsConfig}
                fieldsConfig={arztFieldsConfig}
                hidden={hasNoFamilyDoctor}
                required={true}
            />
        </ECheckinSection>
    );
});

Hausarzt.displayName = 'Hausarzt';

export default Hausarzt;
